import axios from 'axios';
import _ from 'lodash';

export const FETCH_NEXT_PANEL_PAGE = 'FETCH_NEXT_PANEL_PAGE';
export const FETCH_PANEL = 'FETCH_PANEL';
export const SET_FIRST_PAGE = 'SET_FIRST_PAGE';
export const TOGGLE_PANEL_FETCHING = 'TOGGLE_PANEL_FETCHING';

export function fetchNextPanelPage(url, headers, panelId) {
  const request = axios.get(url, headers);
  return {
    type: FETCH_NEXT_PANEL_PAGE,
    payload: request,
    meta: { panelId },
  };
}

async function fetchEventsFromPanel(panelRequest, headers) {
  const data = panelRequest?.data;
  const fetchedWithEventData = data?.items?.member?.map(async item => {
    const linkedEvent = item?.houseIDLinked?.find(linkedId => linkedId?.['@type'] === 'Event');
    const linkedId = linkedEvent?.['@id'];
    const event = linkedId && (await axios.get(linkedId, headers));
    return { ...item, eventData: event?.data };
  });
  if (fetchedWithEventData) {
    _.set(data, 'items.member', (await Promise.all(fetchedWithEventData)) || []);
  }
  return { ...panelRequest, data };
}

export function fetchPanel(url, headers, panelId) {
  const request = axios.get(url, headers).then(request => fetchEventsFromPanel(request, headers));

  return {
    type: FETCH_PANEL,
    payload: request,
    meta: { panelId },
  };
}

export function setFirstPage(panelData, panelId) {
  return {
    type: SET_FIRST_PAGE,
    payload: panelData,
    meta: { panelId },
  };
}

export function toggleFetching(value) {
  return {
    type: TOGGLE_PANEL_FETCHING,
    payload: { value },
  };
}
